module.exports = __webpack_public_path__ + "img/p28.800cae3b.png";